import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Types from '../../../base/common/types.js';
import * as Assert from '../../../base/common/assert.js';

var RegistryImpl = /*#__PURE__*/function () {
  function RegistryImpl() {
    _classCallCheck(this, RegistryImpl);

    this.data = new Map();
  }

  _createClass(RegistryImpl, [{
    key: "add",
    value: function add(id, data) {
      Assert.ok(Types.isString(id));
      Assert.ok(Types.isObject(data));
      Assert.ok(!this.data.has(id), 'There is already an extension with this id');
      this.data.set(id, data);
    }
  }, {
    key: "as",
    value: function as(id) {
      return this.data.get(id) || null;
    }
  }]);

  return RegistryImpl;
}();

export var Registry = new RegistryImpl();